var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteCrossIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.874,
    height: 14.874,
    viewBox: "0 0 14.874 14.874",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-close-5441554",
    d: "M171.98,114.118a.674.674,0,1,0,.953.953l5.716-5.716,5.716,5.716a.674.674,0,0,0,.953-.953L179.6,108.4l5.716-5.716a.674.674,0,0,0-.953-.953l-5.716,5.716-5.716-5.716a.674.674,0,1,0-.953.953L177.7,108.4Z",
    transform: "translate(-171.212 -100.965)",
    fill: "#af1f1e",
    stroke: "#af1f1e",
    strokeWidth: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCrossIcon);
export default __webpack_public_path__ + "static/media/delete_cross_icon.4fd545dade01238efdf792db63f293eb.svg";
export { ForwardRef as ReactComponent };